import { render } from "./QuoteShow.vue?vue&type=template&id=56cdcfed"
import script from "./QuoteShow.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteShow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Quote/QuoteShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56cdcfed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56cdcfed', __exports__)) {
    api.reload('56cdcfed', __exports__)
  }
  
  module.hot.accept("./QuoteShow.vue?vue&type=template&id=56cdcfed", () => {
    api.rerender('56cdcfed', render)
  })

}


export default __exports__